import { render, staticRenderFns } from "./LoginSignup.vue?vue&type=template&id=2e2a44c6&scoped=true&"
import script from "./LoginSignup.vue?vue&type=script&lang=js&"
export * from "./LoginSignup.vue?vue&type=script&lang=js&"
import style0 from "./LoginSignup.vue?vue&type=style&index=0&id=2e2a44c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a44c6",
  null
  
)

export default component.exports